import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
  Typography
} from "@mui/material";

import CountrySelect from "../../../components/common/CountrySelect";
import Select from "../../../components/common/Select";
import { RequiredAsterisk } from "../../../components/professional/RequiredAsterisk";
import CoverImageUpload from "./CoverImageUpload";



const JobOverviewStep = ({ data, onChange, errors, dropDownOptions }) => {
  const {
    preferredCandidateNationalitiesChoices,
    jobTypeChoices,
    pilotTypeChoices,
    aviationCategoryChoices,
  } = dropDownOptions;

  return (
    <Box component="form" noValidate>
      <Grid container spacing={3}>

        <Grid size={{ xs: 12 }}>
          <Typography
            variant="body2"
            fontWeight={600}
            color="text.secondary"
            mb={1}
          >
            Cover Image{" "}
            <Typography
              component="span"
              variant="caption"
              color="text.disabled"
            >
              (optional · recommended 1200 × 400px)
            </Typography>
          </Typography>
          <CoverImageUpload
            value={data.cover_image}
            onChange={(val) => onChange("cover_image", val)}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label={
              <span>
                Job Title <RequiredAsterisk />
              </span>
            }
            value={data.title}
            onChange={(e) => onChange("title", e.target.value)}
            error={!!errors.title}
            helperText={errors.title}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            label={
              <span>
                Location <RequiredAsterisk />
              </span>
            }
            value={data.location}
            onChange={(e) => onChange("location", e.target.value)}
            error={!!errors.location}
            helperText={errors.location}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            select
            fullWidth
            label={
              <span>
                Job Type <RequiredAsterisk />
              </span>
            }
            value={data.job_type}
            onChange={(e) => onChange("job_type", e.target.value)}
            error={!!errors.job_type}
            helperText={errors.job_type}
          >
            {jobTypeChoices.map((t) => (
              <MenuItem key={t.value} value={t.value}>
                {t.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Select
            label={
              <span>
                Pilot Type <RequiredAsterisk />
              </span>
            }
            onChange={(value) => onChange("pilot_type", value)}
            options={pilotTypeChoices}
            value={data.pilot_type}
            error={!!errors?.pilot_type}
            helperText={errors?.pilot_type}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Select
            label={<span>Aviation Category</span>}
            onChange={(value) => onChange("aviation_category", value)}
            options={aviationCategoryChoices}
            value={data.aviation_category}
            error={!!errors?.aviation_category}
            helperText={errors?.aviation_category}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            fullWidth
            type="number"
            label="Number of Positions"
            value={data.no_of_positions}
            slotProps={{ htmlInput: { min: 1 } }}
            onChange={(e) => onChange("no_of_positions", e.target.value)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <CountrySelect
            label="Preferred Candidate Nationalities"
            value={data.preferred_candidate_nationalities}
            id="preferred_candidate_nationalities"
            onChange={(value) =>
              onChange("preferred_candidate_nationalities", value)
            }
            error={!!errors.preferred_candidate_nationalities}
            helperText={errors.preferred_candidate_nationalities}
            multi
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.confidential_posting}
                onChange={(e) =>
                  onChange("confidential_posting", e.target.checked)
                }
              />
            }
            label="Is this a confidential posting?"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default JobOverviewStep;
